











































































import {Component, Vue, Watch} from 'vue-property-decorator';
import {ConvertModule, IBillingSale, ILocation} from '@/stores/modules/convert';
import {find, sortBy, cloneDeep} from 'lodash';
import LocationPicker from '@/components/LocationPicker.vue';
import {BButton, BCard, BCol, BRow, BvTableFieldArray} from 'bootstrap-vue';
import moment from 'moment-timezone';
import CloseIcon from '../assets/icon-close-x.svg';
import {WebService} from '@/services/web.service';

@Component({
	components: {
		LocationPicker: LocationPicker,
		'b-row': BRow,
		'b-col': BCol,
		'b-card': BCard,
		'b-button': BButton,
		CloseIcon: CloseIcon
	},
	computed: {
	}
})
export default class Billing extends Vue {
	public selectedLocationBase: string | null = null;

	public selectedMonth = moment.tz('UTC').startOf('month');

	public fields: BvTableFieldArray = [
		{
			key: 'timestamp',
			label: 'Date',
		},
		{
			key: 'gross',
			label: 'Gross Sales',
			formatter: 'formatMoney'
		},
		{
			key: 'delivered',
			label: 'Delivered',
		},
		{
			key: 'roas',
			label: 'ROAS'
		},
		{
			key: 'total',
			label: 'Total'
		}
	];

	get startMoment() {
		return moment(this.selectedMonth).tz('UTC').startOf('month');
	}

	get endMoment() {
		const endOfMonth = moment(this.selectedMonth).tz('UTC').endOf('month');
		return moment().isBefore(endOfMonth) ? moment() : endOfMonth;
	}

	get items(): IBillingSaleRow[] {
		return sortBy(ConvertModule.billingSalesByLocationBaseAndIntervalAndStartEndDates(
			this.selectedLocationBase,
			'day',
			this.startMoment.unix(),
			this.endMoment.unix(),
		), 'timestamp').reverse().map((billingSale) => {
			const cloned: IBillingSaleRow = cloneDeep(billingSale) as IBillingSaleRow;
			cloned._showDetails = false;
			return cloned;
		});
	}

	get items3() {
		return null;
		// return sortBy(this.getBillingSales(), 'timestamp').reverse();
	}

	get locations() {
		return ConvertModule.locations;
	}

	get selectedLocation(): ILocation | null {
		return find(this.locations, {base: this.selectedLocationBase}) || null;
	}

	async openLocationPicker() {
		this.$bvModal.show('location-picker');
	}

	get items2(): any[] {
		return [
			{
				timestamp: moment().subtract(7, 'day').unix(),
				gross: 15230,
				delivered: 8,
				roas: 5.5,
				total: 6779,
				_showDetails: false
			},
			{
				timestamp: moment().subtract(6, 'day').unix(),
				gross: 14230,
				delivered: 10,
				roas: 3.4,
				total: 7879,
				_showDetails: false
			},
			{
				timestamp: moment().subtract(5, 'day').unix(),
				gross: 21230,
				delivered: 5,
				roas: 4.4,
				total: 10679,
				_showDetails: false
			},
			{
				timestamp: moment().subtract(4, 'day').unix(),
				gross: 11230,
				delivered: 4,
				roas: 3.8,
				total: 4679,
				_showDetails: false
			},
			{
				timestamp: moment().subtract(3, 'day').unix(),
				gross: 8030,
				delivered: 2,
				roas: 3.4,
				total: 1679,
				_showDetails: false
			},
			{
				timestamp: moment().subtract(2, 'day').unix(),
				gross: 41230,
				delivered: 13,
				roas: 2.1,
				total: 16679,
				_showDetails: false
			},
			{
				timestamp: moment().subtract(1, 'day').unix(),
				gross: 11230,
				delivered: 4,
				roas: 3.4,
				total: 4679,
				_showDetails: false
			}
		];
	}

	public reduceAndAverageColumn(columnName: 'roas', ignoreZeros: boolean = true) {
		let itemCount = 0;
		const sum = this.items.reduce((total, item) => {
			if(!ignoreZeros || (ignoreZeros && item[columnName] !== 0)) {
				itemCount++;
			}
			return total += item[columnName];
		}, 0);
		return itemCount === 0 ? 0 : Math.round(sum / itemCount * 100) / 100;
	}

	public reduceColumn(columnName: 'timestamp' | 'delivered' | 'gross' | 'roas') {
		return this.items.reduce((total, item) => {
			return total += item[columnName];
		}, 0);
	}

	locationSelected(locationBase: string | null) {
		this.selectedLocationBase = locationBase;
		this.$bvModal.hide('location-picker');
		this.fetchData();
	}

	async fetchData() {
		await WebService.getBillingSales(
			this.selectedLocationBase,
			'day',
			this.startMoment.format('YYYY-MM-DD'),
			this.endMoment.format('YYYY-MM-DD')
		);
	}

	showDetails(item: IBillingSaleRow, index: number, event: Event) {
		event.preventDefault();
		event.stopPropagation();
		item._showDetails = !item._showDetails;
	}

	async mounted() {
		await WebService.getLocations();
		const locations = ConvertModule.locations;
		if(locations.length > 0) {
			this.locationSelected(locations[0].base);
		}
	}

	prev() {
		this.selectedMonth.subtract(1, 'month');
		this.fetchData();
	}

	next() {
		this.selectedMonth.add(1, 'month');
		this.fetchData();
	}

	async downloadPdf(timestamp: number) {
		await WebService.downloadBillingSalesPdf(this.selectedLocationBase, moment.unix(timestamp).tz('UTC').format('YYYY-MM-DD'));
	}
}

interface IBillingSaleRow extends IBillingSale {
	_showDetails: boolean;
}
